import { NgModule } from '@angular/core';
import { CustomAuthGuard } from './auth.guard';
import { AuthGuard } from '@spartacus/core';
import { LoginGuard } from '@spartacus/storefront';
import { CustomLoginGuard } from './login.guard';
import { CustomCartValidationGuard } from './cart-validation.guard';
import { CartValidationGuard } from '@spartacus/cart/base/core';

@NgModule({
  providers: [
    { provide: AuthGuard, useClass: CustomAuthGuard },
    { provide: LoginGuard, useClass: CustomLoginGuard },
    { provide: CartValidationGuard, useClass: CustomCartValidationGuard },
  ],
})
export class CustomGuardsModule {}
